import script from "./SchedulePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SchedulePage.vue?vue&type=script&lang=ts&setup=true"

import "./SchedulePage.vue?vue&type=style&index=0&id=29eb9bf8&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29eb9bf8"]])

export default __exports__